import apiFetch from '../../apiFetch'

export default function (idVerraco, token) {
  return apiFetch({endPoint: `FichaVerraco/getVerraco?idVerraco=` + idVerraco, method: 'GET', body: null, token: token})
}
